import { render, staticRenderFns } from "./AddictiveStuffAdd.vue?vue&type=template&id=282eccac&scoped=true&"
import script from "./AddictiveStuffAdd.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282eccac",
  null
  
)

export default component.exports